<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 1C7.14416 1.00209 5.36495 1.70639 4.05268 2.95842C2.7404 4.21044 2.0022 5.90795 2.00001 7.67857C1.99778 9.12553 2.49318 10.5332 3.41019 11.6857C3.41019 11.6857 3.6011 11.9255 3.63228 11.9601L9 18L14.3703 11.9571C14.3983 11.9249 14.5898 11.6857 14.5898 11.6857L14.5905 11.6839C15.507 10.5319 16.0022 9.12486 16 7.67857C15.9978 5.90795 15.2596 4.21044 13.9473 2.95842C12.635 1.70639 10.8558 1.00209 9 1ZM9 10.1071C8.49656 10.1071 8.00442 9.96471 7.58582 9.69785C7.16723 9.431 6.84097 9.05171 6.64831 8.60795C6.45565 8.16418 6.40524 7.67588 6.50346 7.20478C6.60168 6.73368 6.84411 6.30095 7.20009 5.96131C7.55608 5.62167 8.00964 5.39037 8.50341 5.29666C8.99718 5.20296 9.50898 5.25105 9.9741 5.43486C10.4392 5.61868 10.8368 5.92995 11.1165 6.32933C11.3962 6.72871 11.5455 7.19825 11.5455 7.67857C11.5446 8.32242 11.2762 8.93967 10.799 9.39494C10.3218 9.85021 9.67484 10.1063 9 10.1071Z" fill="black"/>
  </svg>
</template>
<script>
export default {
  name: "PickupPointIcon"
}
</script>

<style lang="scss">

</style>